import {
  ASSIGMENTS_ORDER_CONFIRM_UPLOAD_DOCUMENT,
  ASSIGMENTS_ORDER_CONFIRM_UPLOAD_DOCUMENT_ERROR,
} from '_models/redux/types';
import axiosTokenInstance from 'services/api/backoffice';

// Action function
export const orderAssignmentConfirmUploadDocumentAction = (params) => async (dispatch) => {
  const { legal_id, order_id, document_id } = params || {};

  // Endpoint: Try & Catch
  try {
    const response = await axiosTokenInstance.post(
      `/api/companies/${legal_id}/linked-up/orders/${order_id}/documents/signed-urls/success`,
      { document_id },
    );

    const { data, status } = response || {};

    dispatch({
      method: 'post',
      payload: data || {},
      status: status || {},
      type: ASSIGMENTS_ORDER_CONFIRM_UPLOAD_DOCUMENT,
    });

    return data || {};
  } catch (e) {
    dispatch({
      method: 'post',
      payload: e || {},
      type: ASSIGMENTS_ORDER_CONFIRM_UPLOAD_DOCUMENT_ERROR,
    });

    throw e;
  }
};
